<template>
    <e-logo title="Table Charts"></e-logo>
</template>

<script>

import ELogo from "@/components/common/display/ELogo.vue";

export default {
    name: "TCLogo",
    components: {ELogo}
}
</script>

<style scoped>

</style>
